import { put, takeLatest, all } from "redux-saga/effects";
import axios from "axios";
import {
  GET_HELP,
  UPDATE_HELP_STATUS,
  ADD_HELP,
  EDIT_HELP,
  DELETE_HELP,
  GET_HELP_DETAILS,
  QUESTION_DROPDOWN_LIST,
  UPDATE_HELP_ORDER_STATUS,
} from "../Constants";
import { defaultHeaders } from "../Constants/DefaultHeaders";
import { logout } from "../../utils";
import {
  GetHelpSuccess,
  GetHelpFailure,
  UpdateHelpStatusSuccess,
  UpdateHelpStatusFailure,
  AddHelpSuccess,
  AddHelpFailure,
  EditHelpSuccess,
  EditHelpFailure,
  DeleteHelpSuccess,
  DeleteHelpFailure,
  GetHelpDetailsSuccess,
  GetHelpDetailsFailure,
  QuestionDropdownListSuccess,
  QuestionDropdownListFailure,
  UpdateHelpOrderStatusSuccess,
  UpdateHelpOrderStatusFailure,
} from "../Actions/HelpAction";

function* GetHelpRequest() {
  try {
    const res = yield axios.get(
      `${process.env.REACT_APP_API_URL}api/admin/services/2`,
      {
        headers: defaultHeaders(),
      }
    );
    if (res.status === 200) {
      yield put(GetHelpSuccess(res.data));
    } else {
      yield put(GetHelpFailure(res));
    }
  } catch (e) {
    if (e.response.status === 401) logout();
    yield put(GetHelpFailure(e));
  }
}

function* helpStatusRequest(actions) {
  const body = {
    id: actions.payload.id,
    status: actions.payload.status,
  };

  try {
    const res = yield axios.post(
      `${process.env.REACT_APP_API_URL}api/admin/change_service_status`,
      body,
      {
        headers: { Authorization: `Bearer ${sessionStorage.getItem("token")}` },
      }
    );
    if (res.status === 200) {
      yield put(UpdateHelpStatusSuccess(res.data));
    } else yield put(UpdateHelpStatusFailure(res));
  } catch (e) {
    if (e.response.status === 401) logout();
    yield put(UpdateHelpStatusFailure(e));
  }
}

function* addHelpRequest(actions) {
  const formData = new FormData();
  formData.append("title", actions.payload.title);
  // formData.append("ios_icon", actions.payload.ios_icon);
  // formData.append("android_icon", actions.payload.android_icon);
  formData.append("icon", actions.payload.icon);
  formData.append("header_title", actions.payload.header_title);
  formData.append("request_button_title", actions.payload.request_button_title);
  formData.append("type", actions.payload.type);
  formData.append("information", actions.payload.information);
  actions.payload.type === 5 &&
    formData.append("question", JSON.stringify(actions.payload.question));
  formData.append("module_type", JSON.stringify(2));
  formData.append("user_type", JSON.stringify(1));
  try {
    const res = yield axios.post(
      `${process.env.REACT_APP_API_URL}api/admin/add_service`,
      formData,
      { headers: defaultHeaders() }
    );
    if (res.status === 200) {
      yield put(AddHelpSuccess(res.data));
    } else {
      yield put(AddHelpFailure(res));
    }
  } catch (e) {
    if (e.response.status === 401) logout();
    yield put(AddHelpFailure(e));
  }
}

function* editHelpRequest(actions) {
  const formData = new FormData();
  formData.append("id", actions.payload.id);
  formData.append("title", actions.payload.title);
  // formData.append("ios_icon", actions.payload.ios_icon);
  // formData.append("android_icon", actions.payload.android_icon);
  formData.append("icon", actions.payload.icon);
  formData.append("header_title", actions.payload.header_title);
  formData.append("request_button_title", actions.payload.request_button_title);
  formData.append("type", actions.payload.type);
  formData.append("information", actions.payload.information);
  formData.append("module_type", JSON.stringify(2));
  formData.append("user_type", JSON.stringify(1));
  actions.payload.type === "5" &&
    formData.append("question", JSON.stringify(actions.payload.question));
  try {
    const res = yield axios.post(
      `${process.env.REACT_APP_API_URL}api/admin/edit_service`,
      formData,
      { headers: defaultHeaders() }
    );
    if (res.status === 200) {
      yield put(EditHelpSuccess(res.data));
    } else yield put(EditHelpFailure(res));
  } catch (e) {
    if (e.response.status === 401) logout();
    yield put(EditHelpFailure(e));
  }
}

function* deleteHelpRequest(actions) {
  try {
    const res = yield axios.delete(
      `${process.env.REACT_APP_API_URL}api/admin/service/${actions.payload}`,
      { headers: defaultHeaders() }
    );
    if (res.status === 200) {
      yield put(DeleteHelpSuccess(res.data));
    } else {
      yield put(DeleteHelpFailure(res));
    }
  } catch (e) {
    if (e.response.status === 401) logout();
    yield put(DeleteHelpFailure(e));
  }
}

function* getHelpDetailsRequest(actions) {
  try {
    const res = yield axios.get(
      `${process.env.REACT_APP_API_URL}api/admin/service_details/${actions.payload}`,
      { headers: defaultHeaders() }
    );
    if (res.status === 200) {
      yield put(GetHelpDetailsSuccess(res.data));
    } else yield put(GetHelpDetailsFailure(res));
  } catch (e) {
    if (e.response.status === 401) logout();
    yield put(GetHelpDetailsFailure(e));
  }
}

function* GetQuestionListRequest() {
  try {
    const res = yield axios.get(
      `${process.env.REACT_APP_API_URL}api/admin/question_dropdown_list`,
      { headers: defaultHeaders() }
    );
    if (res.status === 200) {
      yield put(QuestionDropdownListSuccess(res.data));
    } else {
      yield put(QuestionDropdownListFailure(res));
    }
  } catch (e) {
    if (e.response.status === 401) logout();
    yield put(QuestionDropdownListFailure(e));
  }
}

function* helpOrderStatusRequest(actions) {
  let services = [];
  actions.payload.map((arr) => {
    services.push(arr);
  });
  const body = {
    services,
  };

  try {
    const res = yield axios.post(
      `${process.env.REACT_APP_API_URL}api/admin/change_services_order_number`,
      body,
      { headers: defaultHeaders() }
    );
    if (res.status === 200) {
      yield put(UpdateHelpOrderStatusSuccess(res.data));
    } else yield put(UpdateHelpOrderStatusFailure(res));
  } catch (e) {
    if (e.response.status === 401) logout();
    yield put(UpdateHelpOrderStatusFailure(e));
  }
}

function* actionWatcher() {
  yield takeLatest(GET_HELP, GetHelpRequest);
  yield takeLatest(UPDATE_HELP_STATUS, helpStatusRequest);
  yield takeLatest(ADD_HELP, addHelpRequest);
  yield takeLatest(EDIT_HELP, editHelpRequest);
  yield takeLatest(DELETE_HELP, deleteHelpRequest);
  yield takeLatest(GET_HELP_DETAILS, getHelpDetailsRequest);
  yield takeLatest(QUESTION_DROPDOWN_LIST, GetQuestionListRequest);
  yield takeLatest(UPDATE_HELP_ORDER_STATUS, helpOrderStatusRequest);
}

export default function* HelpSaga() {
  yield all([actionWatcher()]);
}
